<template>
  <div class="l-header__inner">

    <div class="l-header__logo">
      <a href="/"><img src="@/assets/img/header/logo.png" alt="hubsynch"></a>
    </div>

    <div class="l-header__spmenu">
      <div id="nav-btn" class="">
        <a href="#" aria-label="spmenu">
          <div class="btn"><span></span><span></span><span></span></div>
        </a>
      </div>

      <nav class="c-spmenu-menu__list">
        <ul class="login">
          <li><router-link v-if="!isLoggedIn" id="link-login-1" :to="{ name: 'login' }">{{ $t('LOGIN_TITLE')
              }}</router-link></li>
          <!-- <li><router-link v-if="!isLoggedIn" id="link-registration-1" :to="{ name: 'register.agreement' }">{{ $t('TEXT_SIGN_UP') }}</router-link></li> -->
        </ul>
        <ul class="about">
          <li><router-link :to="{ name: 'contact.us' }">{{ $t('LABEL_ENQUIRY') }}</router-link></li>
          <li><router-link :to="{ name: 'user.terms' }">{{ $t('LABEL_MERCHANT_TERM_OF_USE')
              }}</router-link></li>
          <li><router-link :to="{ name: 'privacy.policy' }">{{ $t('LABEL_PRIVACY_POLICY')
              }}</router-link></li>
        </ul>
      </nav>
    </div>

  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { initializeTop } from "@/assets/js/entries/top.js";
import { useSessionStore } from "@/stores/sessionStore";

const sessionStore = useSessionStore();

const isLoggedIn = ref(false);
onMounted(() => {
    isLoggedIn.value = sessionStore.isLoggedIn();
    initializeTop();
});
</script>